import(/* webpackMode: "eager" */ "/home/runner/work/snapcards/snapcards/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/snapcards/snapcards/src/components/landing/Header.tsx");
